import React from 'react';
import { FontIcon } from '@fluentui/react';

import { AssetGroupStatus } from '../../common/asset-group-status';

export const StatusColumn = ({ i18n, isReadOnlyUser, onEditAssetGroupStatus }) => ({
  key: 'Status',
  name: i18n.getString(_TL_('Status')),
  fieldName: 'Status',
  className: 'column-status',
  headerClassName: 'header-status',
  minWidth: 35,
  maxWidth: 35,
  sortable: true,
  isMultiline: false,
  isResizable: false,
  onRenderAggregatedRow: () => {},
  onRenderHeader: () => (
    <FontIcon iconName="StatusCircleInner" />
  ),
  onRender: ({ Id, Status }) => (
    <AssetGroupStatus
      i18n={i18n}
      isReadOnlyUser={isReadOnlyUser}
      assetGroupId={Id}
      assetGroupStatus={Status}
      onEditAssetGroupStatus={onEditAssetGroupStatus}
    />
  ),
});
